import { container } from "assets/jss/material-kit-react.jsx";

const carouselStyle = {
  section: {
  },
  container,
  marginAuto: {
    marginLeft: "auto !important",
    marginRight: "auto !important"
  },
  text:{
  	color: '#000',
    textAlign: 'center',
    fontSize: '1.3rem',
  	'&:hover': {
      color: ' #59C3B1'
    },
    },
    focu:{
     textAlign: 'center',
     fontSize : '1.2rem',
     '&:hover':{
      color: '#32CD32',
     },
    },
     tit:{
     textAlign: 'center',
     fontSize : '1.7rem',
     '&:hover':{
      color: '#6f6f6f',
     },
    }
};

export default carouselStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx